import { Check } from 'lucide-react';

import { cn } from '../lib/cn';
import { Icon } from './icon';

export interface StepsItem {
  key: string;
  label: string;
}

export interface StepsProps {
  /** 목록의 접근 이름 — 예: "회의 단계" · "온보딩 단계". */
  label: string;
  steps: ReadonlyArray<StepsItem>;
  /** 지금 단계의 위치. `steps.length`면 모두 마친 상태다. */
  current: number;
  className?: string;
}

/** 단계 표시 — 누르는 대상이 아니라 지금 상태다. 마친 단계는 체크, 지금 단계만 채운 원이다. */
export function Steps({ label, steps, current, className }: StepsProps) {
  return (
    <ol
      aria-label={label}
      className={cn('gap-snug flex flex-wrap items-center text-sm', className)}
    >
      {steps.map((entry, index) => {
        const done = index < current;
        const active = index === current;
        return (
          <li key={entry.key} className="gap-snug flex items-center">
            {index > 0 ? <span aria-hidden className="bg-line h-px w-6" /> : null}
            <span
              aria-current={active ? 'step' : undefined}
              className={cn(
                'gap-tight flex items-center',
                active ? 'text-ink font-medium' : 'text-ink-muted',
              )}
            >
              <span
                aria-hidden
                className={cn(
                  'flex size-5 items-center justify-center rounded-full text-xs',
                  active && 'bg-action text-action-fg',
                  done && 'bg-highlight text-ink',
                  !active && !done && 'border-line border',
                )}
              >
                {done ? <Icon as={Check} size="sm" /> : index + 1}
              </span>
              {entry.label}
              {done ? <span className="sr-only">(마침)</span> : null}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
